/**
 * Centralized color tokens for Quickstaff.
 * Single source of truth — all components import from here.
 *
 * Brand: Lime green (#CDFE65) + Indigo primary + Teal secondary
 */

export const colors = {
  // Brand
  lime: '#CDFE65',              // original brand lime — CTAs, highlights
  limeAlt: '#9BE22D',           // lime gradient variant
  dark: '#261451',              // deep purple — dark backgrounds
  primary: '#4F46E5',           // indigo-600 — primary actions
  accent: '#0D9488',            // teal-600 — secondary accent
  light: '#F8FAFC',             // slate-50 — light backgrounds
  mintLight: 'rgba(205, 254, 101, 0.15)',
  mintMedium: 'rgba(205, 254, 101, 0.3)',

  // Semantic status (NOT brand — for badges, alerts, indicators)
  success: '#059669',           // emerald-600
  successLight: '#D1FAE5',      // emerald-100
  successText: '#065F46',       // emerald-800
  warning: '#D97706',           // amber-600
  warningLight: '#FEF3C7',      // amber-100
  warningText: '#92400E',       // amber-800
  error: '#DC2626',             // red-600
  errorLight: '#FEE2E2',        // red-100
  errorText: '#991B1B',         // red-800
  info: '#2563EB',              // blue-600
  infoLight: '#DBEAFE',         // blue-100
  infoText: '#1E40AF',          // blue-800

  // Neutral
  muted: '#64748B',             // slate-500
  border: '#E2E8F0',            // slate-200
  surface: '#FFFFFF',           // white
};
